import React from 'react';
import PropTypes from 'prop-types';

import PageHeading from '../PageHeading/PageHeading.js';
import BackLink from '../BackLink/BackLink';
import withBaseLayout from '../BaseLayout/withBaseLayout.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import { getString } from '../../helpers/stringHelpers';

function AccountsLayout(props) {
	const { classes, currentBalances, backAction } = props;

	return (
		<div className={`${classes.root} PageLayout`}>
			<BackLink action={backAction} />
			<PageHeading heading={getString('accountsSection', 'HEADING')} />
			{currentBalances}
			<BackLink action={backAction} gutterTop={true} />
		</div>
	);
}

AccountsLayout.propTypes = {
	classes: PropTypes.object.isRequired,
	currentBalances: PropTypes.object,
	backAction: PropTypes.func.isRequired,
};

AccountsLayout.defaultProps = {};

export default withBaseLayout(withStyles(styles)(AccountsLayout));
